import { appStoreResource } from '@/api'

const state = {
  loading: false,
  apps: []
}

const getters = {
  apps: (state) => {
    return state.apps
  }
}

const actions = {
  loadApps ({ commit }) {
    commit('SET_LOADING', true)

    appStoreResource.all().then(res => {
      console.log(res)

      commit('SET_APPS', res)
      commit('SET_LOADING', false)
    }).catch(err => {
      console.log(err)
    })
  },

  clearApps ({ commit }) {
    commit('SET_APPS', [])
  }
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_APPS (state, apps) {
    state.apps = apps
  }
}

export default { namespaced: true, state, getters, actions, mutations }
